export const TextTheme = {
    sans_100: {
        fontSize: "10.5px",
        lineHeight: "12px",
        fontFamily: "Altform",
    },
    sans_150: {
        fontSize: "11.5px",
        lineHeight: "12px",
        fontFamily: "Altform",
    },
    sans_200: {
        fontSize: "12.5px",
        lineHeight: "16px",
        fontFamily: "Altform",
    },
    sans_300: {
        fontSize: "14.5px",
        lineHeight: "18px",
        fontFamily: "Altform",
    },
    sans_350: {
        fontSize: "15.5px",
        lineHeight: "19px",
        fontFamily: "Altform",
    },
    sans_400: {
        fontSize: "16.5px",
        lineHeight: "20px",
        fontFamily: "Altform",
    },
    sans_500: {
        fontSize: "18.5px",
        lineHeight: "22px",
        fontFamily: "Altform",
    },
    sans_600: {
        fontSize: "20.5px",
        lineHeight: "24px",
        fontFamily: "Altform",
    },
    sans_700: {
        fontSize: "22.5px",
        lineHeight: "26px",
        fontFamily: "Altform",
    },
    sans_800: {
        fontSize: "24.5px",
        lineHeight: "28px",
        fontFamily: "Altform",
    },
    sans_900: {
        fontSize: "26.5px",
        lineHeight: "30px",
        fontFamily: "Altform",
    },
    sans_1000: {
        fontSize: "32.5px",
        lineHeight: "36px",
        fontFamily: "Altform",
    },
    sans_1100: {
        fontSize: "40.5px",
        lineHeight: "44px",
        fontFamily: "Altform",
    },
    sans_1200: {
        fontSize: "48.5px",
        lineHeight: "52px",
        fontFamily: "Altform",
    },
    sans_1300: {
        fontSize: "64.5px",
        lineHeight: "72px",
        fontFamily: "Altform",
    },
    sans_100_med: {
        fontSize: "10px",
        lineHeight: "12px",
        fontWeight: "500",
    },
    sans_150_med: {
        fontSize: "11px",
        lineHeight: "12px",
        fontWeight: "500",
    },
    sans_200_med: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: "500",
    },
    sans_300_med: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "500",
    },
    sans_350_med: {
        fontSize: "15px",
        lineHeight: "19px",
        fontWeight: "500",
    },
    sans_400_med: {
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: "500",
    },
    sans_500_med: {
        fontSize: "18px",
        lineHeight: "22px",
        fontWeight: "500",
    },
    sans_600_med: {
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: "500",
    },
    sans_700_med: {
        fontSize: "22px",
        lineHeight: "26px",
        fontWeight: "500",
    },
    sans_800_med: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: "500",
    },
    sans_900_med: {
        fontSize: "26px",
        lineHeight: "30px",
        fontWeight: "500",
    },
    sans_1000_med: {
        fontSize: "32px",
        lineHeight: "36px",
        fontWeight: "500",
    },
    sans_1100_med: {
        fontSize: "40px",
        lineHeight: "44px",
        fontWeight: "500",
    },
    sans_1200_med: {
        fontSize: "48px",
        lineHeight: "52px",
        fontWeight: "500",
    },
    sans_1300_med: {
        fontSize: "64px",
        lineHeight: "72px",
        fontWeight: "500",
    },
    sans_100_semi: {
        fontSize: "10.5px",
        lineHeight: "12px",
        fontFamily: "Altform Semibold",
    },
    sans_150_semi: {
        fontSize: "11.5px",
        lineHeight: "12px",
        fontFamily: "Altform Semibold",
    },
    sans_200_semi: {
        fontSize: "12.5px",
        lineHeight: "16px",
        fontFamily: "Altform Semibold",
    },
    sans_300_semi: {
        fontSize: "14.5px",
        lineHeight: "18px",
        fontFamily: "Altform Semibold",
    },
    sans_350_semi: {
        fontSize: "15.5px",
        lineHeight: "19px",
        fontFamily: "Altform Semibold",
    },
    sans_400_semi: {
        fontSize: "16.5px",
        lineHeight: "20px",
        fontFamily: "Altform Semibold",
    },
    sans_500_semi: {
        fontSize: "18.5px",
        lineHeight: "22px",
        fontFamily: "Altform Semibold",
    },
    sans_600_semi: {
        fontSize: "20.5px",
        lineHeight: "24px",
        fontFamily: "Altform Semibold",
    },
    sans_700_semi: {
        fontSize: "22.5px",
        lineHeight: "26px",
        fontFamily: "Altform Semibold",
    },
    sans_800_semi: {
        fontSize: "24.5px",
        lineHeight: "28px",
        fontFamily: "Altform Semibold",
    },
    sans_900_semi: {
        fontSize: "26.5px",
        lineHeight: "30px",
        fontFamily: "Altform Semibold",
    },
    sans_1000_semi: {
        fontSize: "32.5px",
        lineHeight: "36px",
        fontFamily: "Altform Semibold",
    },
    sans_1100_semi: {
        fontSize: "40.5px",
        lineHeight: "44px",
        fontFamily: "Altform Semibold",
    },
    sans_1200_semi: {
        fontSize: "48.5px",
        lineHeight: "52px",
        fontFamily: "Altform Semibold",
    },
    sans_1300_semi: {
        fontSize: "64.5px",
        lineHeight: "68px",
        fontFamily: "Altform Semibold",
    },
    sans_100_bold: {
        fontSize: "10px",
        lineHeight: "12px",
        fontWeight: "700",
    },
    sans_150_bold: {
        fontSize: "11px",
        lineHeight: "12px",
        fontWeight: "700",
    },
    sans_200_bold: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: "700",
    },
    sans_300_bold: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "700",
    },
    sans_350_bold: {
        fontSize: "15px",
        lineHeight: "19px",
        fontWeight: "700",
    },
    sans_400_bold: {
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: "700",
    },
    sans_500_bold: {
        fontSize: "18px",
        lineHeight: "22px",
        fontWeight: "700",
    },
    sans_600_bold: {
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: "700",
    },
    sans_700_bold: {
        fontSize: "22px",
        lineHeight: "26px",
        fontWeight: "700",
    },
    sans_800_bold: {
        fontSize: "24px",
        lineHeight: "28px",
        fontWeight: "700",
    },
    sans_900_bold: {
        fontSize: "26px",
        lineHeight: "30px",
        fontWeight: "700",
    },
    sans_1000_bold: {
        fontSize: "32px",
        lineHeight: "36px",
        fontWeight: "700",
    },
    sans_1100_bold: {
        fontSize: "40px",
        lineHeight: "44px",
        fontWeight: "700",
    },
    sans_1200_bold: {
        fontSize: "48px",
        lineHeight: "52px",
        fontWeight: "700",
    },
    sans_1300_bold: {
        fontSize: "64px",
        lineHeight: "72px",
        fontWeight: "700",
    },
};

export const ButtonTheme = {
    sans_button_100: {
        fontSize: "13.5px",
        lineHeight: "18px",
        fontFamily: "Altform Semibold",
    },
    sans_button_200: {
        fontSize: "15.5px",
        lineHeight: "20px",
        fontFamily: "Altform Semibold",
    },
    sans_button_300: {
        fontSize: "17.5px",
        lineHeight: "22px",
        fontFamily: "Altform Semibold",
    },
    sans_button_100_light: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: "500",
    },
    sans_button_200_light: {
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: "500",
    },
    sans_button_300_light: {
        fontSize: "18px",
        lineHeight: "22px",
        fontWeight: "500",
    },
};

export const TallTextTheme = {
    sans_text_100: {
        fontSize: "12.5px",
        lineHeight: "20px",
        fontFamily: "Altform",
    },
    sans_text_200: {
        fontSize: "14.5px",
        lineHeight: "22px",
        fontFamily: "Altform",
    },
    sans_text_300: {
        fontSize: "16.5px",
        lineHeight: "24px",
        fontFamily: "Altform",
    },
    sans_text_400: {
        fontSize: "18.5px",
        lineHeight: "26px",
        fontFamily: "Altform",
    },
};

export const ColorTheme = {
    Red: {
        color: "#ff385b",
    },
    Blue: {
        color: "#262626",
    },
    Black: {
        color: "#262626",
        opacityColor: "rgba(0, 0, 0, 0.35)",
    },
    Grey: {
        // color: "#737373",
        color: "#64645f",
    },
    Grey1: {
        color: "#cccccc",
    },
    Grey2: {
        color: "#e6e6e6",
    },
    Grey3: {
        color: "#f1f1f1",
    },
    Grey4: {
        color: "#f6f6f6",
    },
    Grey5: {
        color: "#fafafa",
    },
    Accent: {
        color: "#fdfaf9",
    },
    White: {
        color: "#ffffff",
    },
    Red1: {
        color: "#ed555b",
    },
    Yellow: {
        color: "#ffa01d",
    },
    Green: {
        color: "#30c300",
    },
    Red2: {
        color: "#e42151",
    },
    Khaki: {
        color: "#F7F4F0",
    },
};

export const GradientTheme = {
    Red: {
        background: "linear-gradient(93deg, #E2194A 0%, #E1175A 49%, #DE0B57 100%)",
    },
    Black: {
        background: "linear-gradient(315deg, #1D1D1F 0%, #1D1D1F 49.5%, #262626 100%)",
    },
};

export const ShadowTheme = {
    shadow_50: {
        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.16)",
    },
    shadow_100: {
        boxShadow: "0px 0px 1px 0 rgba(0, 0, 0, 0.05), 1.3px 3px 16px 0 rgba(0, 0, 0, 0.1)",
    },
    shadow_200: {
        boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.12)",
    },
    shadow_300: {
        boxShadow: "2px 6px 24px -4px rgba(0, 0, 0, 0.25)",
    },
    shadow_400: {
        boxShadow: "2px 6px 24px -4px rgba(0, 0, 0, 0.25), 2px 6px 24px -4px rgba(0, 0, 0, 0.25)",
    },
};

export const BorderRadiusTheme = {
    radius_4: {
        borderRadius: "4px",
    },
    radius_8: {
        borderRadius: "8px",
    },
    radius_12: {
        borderRadius: "12px",
    },
    radius_16: {
        borderRadius: "16px",
    },
    radius_24: {
        borderRadius: "24px",
    },
    radius_32: {
        borderRadius: "32px",
    },
    radius_100: {
        borderRadius: "100px",
    },
};

export const SpacingTheme = {
    spacing_100: {
        padding: "4px",
        margin: "4px",
        gap: "4px",
    },
    spacing_200: {
        padding: "8px",
        margin: "8px",
        gap: "8px",
    },
    spacing_250: {
        padding: "12px",
        margin: "12px",
        gap: "12px",
    },
    spacing_300: {
        padding: "16px",
        margin: "16px",
        gap: "16px",
    },
    spacing_350: {
        padding: "20px",
        margin: "20px",
        gap: "20px",
    },
    spacing_400: {
        padding: "24px",
        margin: "24px",
        gap: "24px",
    },
    spacing_500: {
        padding: "32px",
        margin: "32px",
        gap: "32px",
    },
    spacing_600: {
        padding: "48px",
        margin: "48px",
        gap: "48px",
    },
    spacing_700: {
        padding: "64px",
        margin: "64px",
        gap: "64px",
    },
    spacing_800: {
        padding: "80px",
        margin: "80px",
        gap: "80px",
    },
    spacing_900: {
        padding: "96px",
        margin: "96px",
        gap: "96px",
    },
    spacing_1000: {
        padding: "128px",
        margin: "128px",
        gap: "128px",
    },
};
